import { render, staticRenderFns } from "./RegisterIndividual.vue?vue&type=template&id=6eec6758&scoped=true&"
import script from "./RegisterIndividual.vue?vue&type=script&lang=js&"
export * from "./RegisterIndividual.vue?vue&type=script&lang=js&"
import style0 from "./RegisterIndividual.vue?vue&type=style&index=0&id=6eec6758&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eec6758",
  null
  
)

export default component.exports